/**
 * Convert a string to a URL-safe slug.
 * Used to derive definition anchors from their titles, e.g.
 * slugify('World Rankings Competition') === 'world-rankings-competition'
 */
export function slugify(input: string): string {
  return input
    .trim()
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '') // strip combining diacritics
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-') // non-alphanumeric runs → single dash
    .replace(/^-+|-+$/g, ''); // trim leading/trailing dashes
}
